<template>
  <div class="wspo-hero" ref="hero">
    <div class="wspo-layout-row wspo-layout-row-short">
      <Typelist v-if="wspoWidth > 1032" />
      <Select
        v-else
        type="types"
        label="По типу"
        :output="type && types.find(t => t.id === type).name"
        :onSelect="handleTypeSelect"
        :options="types"
        :selected="type"
      />
    </div>

    <div class="wspo-layout-row wspo-layout-row-short">
      <div class="wspo-hero-countries">
        <Select
          type="departures"
          label="Город вылета"
          :output="departure && departures.find(d => d.id === departure).name"
          :onSelect="handleDepartureSelect"
          :options="departures"
          :selected="departure"
        />
        <Countrylist v-if="wspoWidth > 1032" />

        <Select
          v-else
          type="countries"
          label="По стране"
          :output="
            country !== undefined && countries.find(c => c.id === country).name
          "
          :onSelect="handleCountrySelect"
          :options="countries"
          :selected="country"
        />
      </div>
      <div class="wspo-hero-tours">
        <div
          class="wspo-hero-tours-item"
          v-for="tour in tours"
          :key="tour.id"
          :class="{
            'wspo-large': mode === 'max'
          }"
          @click="setTour(tour.id)"
        >
          <img
            :src="'//well.ru/' + tour.detail_picture"
            alt
            class="wspo-hero-tour-image"
          />
          <div class="wspo-hero-tour-content">
            <div class="wspo-hero-tour-flydata">
              <div class="wspo-hero-tour-country">{{ tour.country }}</div>
              <div class="wspo-hero-tour-date">{{ tour.date }}</div>
            </div>

            <div class="wspo-hero-tour-title">{{ tour.name }}</div>
            <div class="wspo-hero-tour-hotel">
              {{ tour.hotel.toLowerCase() }}
              <div class="wspo-stars">
                <div
                  v-for="star in parseInt(tour.cat, 10)"
                  :key="star"
                  class="wspo-star wspo-icon"
                ></div>
              </div>
            </div>
            <div
              class="wspo-price wspo-hero-tour-price"
              v-html="currencyString(tour.price)"
            ></div>
            <div class="wspo-small">
              цена за номер на {{ tour.nights
              }}{{
                tour.nights > 4
                  ? ' ночей'
                  : tour.nights == 1
                  ? ' ночь'
                  : ' ночи'
              }}
            </div>
            <div class="wspo-button-main">Смотреть тур</div>
          </div>
        </div>
      </div>

      <div class="wspo-hero-footer">
        <div
          class="wspo-button-main"
          style="display: inline-flex; width: unset"
          v-if="isTourCountLimited"
          @click="setTourCountUnlimited()"
        >
          Смотреть все отборные туры
        </div>
        <div class="wspo-hero-footer-lastword">
          Все туры, опубликованные на сайте, не являются публичной офертой и
          носят рекламно-информационный характер. В случае отсутствия в продаже
          именно этого, выбранного Вами тура, наши менеджеры приложат все
          усилия, чтобы подобрать Вам достойную альтернативу
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Typelist from '@/components/Typelist.vue';
import Countrylist from '@/components/Countrylist.vue';
import Select from '@/components/controls/Select.vue';
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'Hero',
  components: {
    Typelist,
    Countrylist,
    Select
  },
  computed: {
    ...mapState([
      'type',
      'types',
      'country',
      'mode',
      'departure',
      'departures',

      'isTourCountLimited'
    ]),
    ...mapGetters([
      'countriesByType',
      'toursByTypeByCountry',
      'currencyString'
    ]),
    tours() {
      const tourscount = window.WSPO_COUNT || 18;
      return this.isTourCountLimited
        ? this.toursByTypeByCountry.slice(0, tourscount)
        : this.toursByTypeByCountry;
    },
    countries() {
      return [{ id: null, name: 'Любая страна' }, ...this.countriesByType];
    },
    wspoWidth() {
      // return this.$refs.offsetWidth;
      // console.log(document.getElementById('wspo').offsetWidth);
      return document.getElementById('wspo').offsetWidth;
    }
  },
  methods: {
    ...mapMutations([
      'setType',
      'setCountry',
      'setMode',
      'setTour',
      'setDeparture',
      'setTourCountUnlimited'
    ]),
    handleTypeSelect(e) {
      e = e || window.event;
      this.setType(e.target.dataset.id);
    },
    handleCountrySelect(e) {
      e = e || window.event;
      this.setCountry(e.target.dataset.id);
    },
    handleDepartureSelect(e) {
      e = e || window.event;
      this.setDeparture(e.target.dataset.id);
    }
  }
};
</script>

<style scoped>
.wspo-hero {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
}
.wspo-hero-countries {
  flex: 1 200px;
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
  /* max-width: 200px; */
  padding: 8px 18px 8px 0;
}
@media (max-width: 1000px) {
  .wspo-hero-countries {
    max-width: unset;
    margin: 0 auto;
    padding: 0 0 18px;
  }
}
.wspo-hero-tours {
  flex: 4 800px;
  padding: 12px 0;
  display: flex;
  flex-flow: row wrap;
}
.wspo-hero-tours-item {
  flex: 1 0 200px;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  position: relative;
  height: 250px;
  border-radius: 2px;
  box-shadow: 0 0 1px var(--color-text-5), 0 0 8px var(--color-bg-dark);
  margin-bottom: 12px;
  margin-right: 18px;
}
.wspo-hero-tours-item:nth-child(3n + 3) {
  margin-right: 0;
}
.wspo-hero-tours-item.wspo-large {
  flex: 4 0 800px;
  height: 250px;
  margin-right: 0;
}
.wspo-hero-tours-item:last-child {
  margin-right: 0;
}
@media (max-width: 1000px) {
  .wspo-hero-tours-item {
    padding: 0;
    flex: 4 0 800px;
    height: unset !important;
    margin: 0 0 12px;
  }
}
.wspo-hero-tour-image {
  position: absolute;
  width: 100%;
  max-width: 100%;
  height: 200px;
  object-fit: cover;
  z-index: 0;
}
.wspo-hero-tours-item.wspo-large .wspo-hero-tour-image {
  height: 100%;
}
@media (max-width: 1000px) {
  .wspo-hero-tours-item.wspo-large .wspo-hero-tour-image {
    height: 250px;
  }
}
.wspo-hero-tour-content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px 18px 24px;
  z-index: 1;
  margin-top: 150px;
  background: var(--color-paper);
  height: calc(100% - 138px);
  transition: 0.3s;
}
.wspo-hero-tours-item.wspo-large .wspo-hero-tour-content {
  margin-left: 66%;
  margin-top: 0;
  background: linear-gradient(var(--color-paper) 70%, #fff0 99%);
  transition: 0.3s;
  height: auto;
}
@media (max-width: 600px) {
  .wspo-hero-tour-content {
    margin-left: 0 !important;
    margin-top: 150px !important;
    background: var(--color-paper) !important;
  }
}
@media (min-width: 601px) {
  .wspo-hero-tours-item:not(.wspo-large) .wspo-hero-tour-title,
  .wspo-hero-tours-item:not(.wspo-large) .wspo-hero-tour-hotel,
  .wspo-hero-tours-item:not(.wspo-large) .wspo-button-main {
    display: none;
  }
  .wspo-hero-tours-item:not(.wspo-large):hover .wspo-hero-tour-title,
  .wspo-hero-tours-item:not(.wspo-large):hover .wspo-hero-tour-hotel,
  .wspo-hero-tours-item:not(.wspo-large):hover .wspo-button-main {
    display: block;
    transition: 0.3s;
  }
  .wspo-hero-tours-item:not(.wspo-large):hover .wspo-hero-tour-content {
    margin-top: 0;
    height: 100%;
    transition: 0.3s;
  }
}
.wspo-hero-tour-title {
  margin-top: 4px;
  font-size: 15px;
  font-weight: 600;
}
.wspo-hero-tour-price {
  margin-top: 4px;
  color: var(--color-main);
}
.wspo-hero-tour-flydata {
  display: flex;
  flex-flow: row wrap;
  margin-left: -8px;
}
.wspo-hero-tour-flydata .wspo-hero-tour-country,
.wspo-hero-tour-flydata .wspo-hero-tour-date {
  padding: 4px 8px;
  border-radius: 20px;
  background-color: var(--color-bg);
  margin-right: 4px;
}
.wspo-hero-tour-hotel {
  font-size: 13px;
  text-transform: capitalize;
}

.wspo-hero-footer {
  padding-bottom: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wspo-hero-footer-lastword {
  margin-top: 12px;
  font-size: 12px;
  text-align: center;
}

/* stars */
.wspo-stars {
  display: inline-flex;
  align-items: center;
}
.wspo-star,
.wspo-star-unchecked {
  margin-right: 2px;
  cursor: pointer;
}
.wspo-star-unchecked:before,
.wspo-star:before {
  content: '\f005';
  font-size: 10px;
}
.wspo-star:before {
  color: var(--color-third);
}
.wspo-star-unchecked:before {
  color: var(--color-alt-5);
}
</style>
